module.exports = __webpack_public_path__ + "img/icon_chip_10.ba0cac46.png";